module.exports = __webpack_public_path__ + "img/btn-bg-pink.png?ecca56c6df38af050eb8cde25206e30d";